import React from "react";
import * as Styled from "./styles";
import { Typography } from "@mui/material";
import {
  SellOutlined as SellOutlinedIcon,
  LocationOn as LocationOnIcon,
} from "@mui/icons-material";
import { CheckoutItemProps } from "store/modules/Checkout/types.store";
// eslint-disable-next-line import/no-duplicates
import { addHours } from "date-fns";
// eslint-disable-next-line import/no-duplicates
import { getSchedulingDayLabel, formatTimeLocal } from "utils/dateUtils";
import { formatStreetAddress } from "utils/formatByText";

export const ScheduledOrderCard = ({ data }: { data: CheckoutItemProps }) => {
  return (
    <Styled.ScheduledOrderCard>
      <Styled.ScheduledOrderCardClientName>
        <Typography variant="subtitle1">{data.customer.name}</Typography>
      </Styled.ScheduledOrderCardClientName>
      <Styled.ScheduledOrderCardLocationContainer>
        <LocationOnIcon fontSize="small" />
        <Styled.ScheduledOrderCardLocation>
          <Typography variant="subtitle2">
            {formatStreetAddress(data.delivery.address)}
          </Typography>

          <Typography variant="caption">
            {data.delivery.address?.neighborhood}
          </Typography>
        </Styled.ScheduledOrderCardLocation>
      </Styled.ScheduledOrderCardLocationContainer>
      <Styled.ScheculedOrderCardTimeRow>
        <Styled.ScheculedOrderCardTime>
          <SellOutlinedIcon fontSize="small" />
          <Typography variant="caption">
            {data.scheduling.startAt ? (
              <>
                Agendado para{" "}
                {getSchedulingDayLabel(new Date(data.scheduling.startAt))} entre{" "}
                {formatTimeLocal(new Date(data.scheduling.startAt))} e{" "}
                {formatTimeLocal(
                  addHours(new Date(data.scheduling.startAt), 1),
                )}
              </>
            ) : (
              "Agendamento pendente"
            )}
          </Typography>
        </Styled.ScheculedOrderCardTime>
        <Styled.ScheculedOrderCardItem>
          {data.items.map((product) => (
            <React.Fragment key={product.productId}>
              <img
                src={product.imageUrl}
                alt={product.name}
                width={42}
                height={42}
              />
              <Typography variant="caption" key={product.productId}>
                {product.quantity} {product.name}
              </Typography>
            </React.Fragment>
          ))}
        </Styled.ScheculedOrderCardItem>
      </Styled.ScheculedOrderCardTimeRow>
    </Styled.ScheduledOrderCard>
  );
};
